export default __webpack_public_path__ + "static/article-real-stories-saving-spending-lending-kate-7874394d681038be2785fa0c1b1c0dda.jpg";